function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { insert } from 'text-field-edit';
/*

# Global notes

Indent and unindent affect characters outside the selection, so the selection has to be expanded (`newSelection`) before applying the replacement regex.

The `unindent` selection expansion logic is a bit convoluted and I wish a genius would rewrite it more efficiently.

*/

export function indent(element) {
  var _a;

  var selectionStart = element.selectionStart,
      selectionEnd = element.selectionEnd,
      value = element.value;
  var selectedText = value.slice(selectionStart, selectionEnd); // The first line should be indented, even if it starts with `\n`
  // The last line should only be indented if includes any character after `\n`

  var lineBreakCount = (_a = /\n/g.exec(selectedText)) === null || _a === void 0 ? void 0 : _a.length;

  if (lineBreakCount > 0) {
    // Select full first line to replace everything at once
    var firstLineStart = value.lastIndexOf('\n', selectionStart - 1) + 1;
    var newSelection = element.value.slice(firstLineStart, selectionEnd - 1);
    var indentedText = newSelection.replace(/^|\n/g, // Match all line starts
    '$&\t');
    var replacementsCount = indentedText.length - newSelection.length; // Replace newSelection with indentedText

    element.setSelectionRange(firstLineStart, selectionEnd - 1);
    insert(element, indentedText); // Restore selection position, including the indentation

    element.setSelectionRange(selectionStart + 1, selectionEnd + replacementsCount);
  } else {
    insert(element, '\t');
  }
}

function findLineEnd(value, currentEnd) {
  // Go to the beginning of the last line
  var lastLineStart = value.lastIndexOf('\n', currentEnd - 1) + 1; // There's nothing to unindent after the last cursor, so leave it as is

  if (value.charAt(lastLineStart) !== '\t') {
    return currentEnd;
  }

  return lastLineStart + 1; // Include the first character, which will be a tab
} // The first line should always be unindented
// The last line should only be unindented if the selection includes any characters after `\n`


export function unindent(element) {
  var selectionStart = element.selectionStart,
      selectionEnd = element.selectionEnd,
      value = element.value; // Select the whole first line because it might contain \t

  var firstLineStart = value.lastIndexOf('\n', selectionStart - 1) + 1;
  var minimumSelectionEnd = findLineEnd(value, selectionEnd);
  var newSelection = element.value.slice(firstLineStart, minimumSelectionEnd);
  var indentedText = newSelection.replace(/(^|\n)(\t| {1,2})/g, '$1');
  var replacementsCount = newSelection.length - indentedText.length; // Replace newSelection with indentedText

  element.setSelectionRange(firstLineStart, minimumSelectionEnd);
  insert(element, indentedText); // Restore selection position, including the indentation

  var firstLineIndentation = /\t| {1,2}/.exec(value.slice(firstLineStart, selectionStart));
  var difference = firstLineIndentation ? firstLineIndentation[0].length : 0;
  var newSelectionStart = selectionStart - difference;
  element.setSelectionRange(selectionStart - difference, Math.max(newSelectionStart, selectionEnd - replacementsCount));
}
export function eventHandler(event) {
  if (event.defaultPrevented) {
    return;
  }

  var textarea = event.target;

  if (event.key === 'Tab' && !event.metaKey && !event.altKey && !event.ctrlKey) {
    if (event.shiftKey) {
      unindent(textarea);
    } else {
      indent(textarea);
    }

    event.preventDefault();
  }
}
export function watch(elements) {
  if (typeof elements === 'string') {
    elements = document.querySelectorAll(elements);
  } else if (elements instanceof HTMLTextAreaElement) {
    elements = [elements];
  }

  var _iterator = _createForOfIteratorHelper(elements),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var element = _step.value;
      element.addEventListener('keydown', eventHandler);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}